import { ITermDictionary }                        from './LangTypes';

export const ACTIVITY_CRITICALITY_DICTIONARY: ITermDictionary['ACTIVITY_CRITICALITY'] = {
	CRITICAL: {
		LABEL:       'Critical',
		DESCRIPTION: "This item is critical to the success of the product's commercialization. It should have a plan and schedule in place, with an appropriate budget to provide it's operation.",
	},
	PRIORITY: {
		LABEL:       'Priority',
		DESCRIPTION: "This item should take a priority when deciding what to consider during a product's commercialization. It should have a plan and schedule in place, with an appropriate budget to provide it's operation.",
	},
	MODERATE: {
		LABEL:       'Moderate',
		DESCRIPTION: "This item is a usually involved with product's commercialization. While it should have a plan and schedule in place, it could be considered non-essential when appropriate analysis has taken place.",
	},
	MINOR:    {
		LABEL:       'Minor',
		DESCRIPTION: "This item can be involved with a product's commercialization map, but is not necessarily needed to achieve commercialization. If planned for, it should have a plan and schedule in place, but it can be considered non-essential when appropriate analysis has taken place or a smaller project scope is deired.",
	},
}

export const ACTIVITY_STATUSES_DICTIONARY: ITermDictionary['ACTIVITY_STATUSES'] = {
	NOTSTARTED: {
		LABEL:       'Not Started',
		DESCRIPTION: `This activity has not been started yet.`,
	},
	INCOMPLETE: {
		LABEL:       'In Progress',
		DESCRIPTION: "This activity is underway with at least some work complete.",
	},
	COMPLETE:   {
		LABEL:       'Complete',
		DESCRIPTION: "This activity has been marked as complete.",
	},
	EXCLUDED:   {
		LABEL:       'Excluded',
		DESCRIPTION: "This activity has been excluded by the project team and does not contribute to any objective completion metrics.",
	},
}

export const BUDGET_COSTS_DICTIONARY: ITermDictionary['BUDGET_COSTS'] = {

	PROFESSIONAL_FEE_COSTS:        {
		LABEL:       'Professional Fees',
		DESCRIPTION: 'Any cost incurred when a resource has not been hired to do the activity. Does not apply to custom operational values.'
	},
	// OPERATIONAL_COSTS:             {
	// 	LABEL:       'Operational Costs',
	// 	DESCRIPTION: 'One-time stand up costs that help get an activity started. Applies to custom operational values.'
	// },
	SCHEDULED_COSTS:              {
		LABEL:       'Scheduled Costs',
		DESCRIPTION: 'Custom costs that support an activity.'
	},
	ONGOING_COSTS:                 {
		LABEL:       'Ongoing Costs',
		DESCRIPTION: 'Forecasted reoccuring costs that help keep an activity maintained. Applies to custom ongoing values.'
	},
	HEADCOUNT_COST:                {
		LABEL:       'Hiring Costs',
		DESCRIPTION: 'Cost to hire a resource, calculated based on compensation you provide to the hiring manager.'
	},
	CUSTOM_DATA_CATEGORICAL_COSTS: {
		LABEL:       'Custom Data',
		DESCRIPTION: 'Any cost added to the project by your team or external source.'
	},
	CUSTOM_DATA_HIRING_COSTS:      {
		LABEL:       'Custom Hiring',
		DESCRIPTION: 'Any hiring cost added to the project by your team or external source.'
	}
}

export const OBJECTIVE_STATUSES_DICTIONARY: ITermDictionary['OBJECTIVE_STATUSES'] = {
	NOT_STARTED:      {
		LABEL:       'Not Started',
		DESCRIPTION: "This objective has not been started yet.",
	},
	IN_PROGRESS_LOW:  {
		LABEL:       'Started',
		DESCRIPTION: "This objective is in progress, with at least 25% activity work started or complete.",
	},
	IN_PROGRESS_MED:  {
		LABEL:       'In Progress',
		DESCRIPTION: "This objective is in progress, with at least 50% activity work started or complete.",
	},
	IN_PROGRESS_HIGH: {
		LABEL:       'Nearing Completion',
		DESCRIPTION: "This objective is in progress, with at least 75% activity work started or complete.",
	},
	COMPLETE:         {
		LABEL:       'Complete',
		DESCRIPTION: "This objective's activity set has been completed.",
	},
}

export const INTAKE_QUESTION_CONTEXTS_DICTIONARY: ITermDictionary['INTAKE_QUESTION_CONTEXTS'] = {
	CORE:     {
		LABEL:       'Core Questions',
		DESCRIPTION: "Questions needed to be answered in order to get baseline details for a project.",
	},
	ADDITIVE: {
		LABEL:       'Additive / Conditional Questions',
		DESCRIPTION: "Questions that help clarify previous answers, or help supplement certain kinds of projects.",
	},
	PROJECT:  {
		LABEL:       'Project-based Questions',
		DESCRIPTION: "Information that is useful to have about a project.",
	},
}

export const SYSTEM_ROLES_DICTIONARY: ITermDictionary['SYSTEM_ROLES'] = {
	CORVALADMIN:         {
		LABEL:       'System Administrator',
		DESCRIPTION: "Users with the highest tier of access / control within the Corval platform.",
	},
	ACCOUNTSADMIN:       {
		LABEL:       'System Administrator (Accounts only)',
		DESCRIPTION: "Users with access / control over this tenant's accounts configurations.",
	},
	DECISIONENGINEADMIN: {
		LABEL:       'System Administrator (DEM only)',
		DESCRIPTION: "Users with access / control over this tenant's DEM configurations.",
	},
	MEMBER:              {
		LABEL:       'System User',
		DESCRIPTION: "Users with minimal control over this tenant's platform configurations.",
	},
}

export const ORGANIZATIONAL_ROLES_DICTIONARY: ITermDictionary['ORGANIZATIONAL_ROLES'] = {
	ADMIN:  {
		LABEL:       'Organization Administrator',
		DESCRIPTION: "Users with the highest tier of access / control within an organization.",
	},
	MEMBER: {
		LABEL:       'Organization Member',
		DESCRIPTION: "Users with minimal control over an organization.",
	},
}

export const PROJECT_ROLES_DICTIONARY: ITermDictionary['PROJECT_ROLES'] = {
	ADMIN:  {
		LABEL:       'Administrator',
		DESCRIPTION: "Users with the highest tier of access / control within a project.",
	},
	MEMBER: {
		LABEL:       'Member',
		DESCRIPTION: "Users with minimal control over a project.",
	},
	VIEWER: {
		LABEL:       'Viewer',
		DESCRIPTION: "Users with read-only access to a project.",
	},
}

export const PROJECT_DETAILS_DICTIONARY: ITermDictionary['PROJECT_DETAILS'] = {
	NAME:             {
		LABEL:       'Project Name',
		DESCRIPTION: "The name of this commercialization plan.",
	},
	ASSET_NAME:       {
		LABEL:       'Asset Name',
		DESCRIPTION: "The asset name is the name your team uses internally.",
	},
	ASSET_INDICATION: {
		LABEL:       'Asset Indication',
		DESCRIPTION: "The indication of the asset refers to the use of that asset for treating a particular problem, such as a disease.",
	}
}

export const DEFAULT_TERM_DICTIONARY: ITermDictionary = {
	ACTIVITY_CRITICALITY:     ACTIVITY_CRITICALITY_DICTIONARY,
	ACTIVITY_STATUSES:        ACTIVITY_STATUSES_DICTIONARY,
	OBJECTIVE_STATUSES:       OBJECTIVE_STATUSES_DICTIONARY,
	INTAKE_QUESTION_CONTEXTS: INTAKE_QUESTION_CONTEXTS_DICTIONARY,
	SYSTEM_ROLES:             SYSTEM_ROLES_DICTIONARY,
	ORGANIZATIONAL_ROLES:     ORGANIZATIONAL_ROLES_DICTIONARY,
	PROJECT_ROLES:            PROJECT_ROLES_DICTIONARY,
	PROJECT_DETAILS:          PROJECT_DETAILS_DICTIONARY,
	BUDGET_COSTS:             BUDGET_COSTS_DICTIONARY,
};
